/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MarketingChannelOverviewItemData } from './MarketingChannelOverviewItemData';
import {
    MarketingChannelOverviewItemDataFromJSON,
    MarketingChannelOverviewItemDataFromJSONTyped,
    MarketingChannelOverviewItemDataToJSON,
    MarketingChannelOverviewItemDataToJSONTyped,
} from './MarketingChannelOverviewItemData';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';

/**
 * 
 * @export
 * @interface MarketingChannelOverviewCollectionData
 */
export interface MarketingChannelOverviewCollectionData {
    /**
     * 
     * @type {Array<MarketingChannelOverviewItemData>}
     * @memberof MarketingChannelOverviewCollectionData
     */
    items?: Array<MarketingChannelOverviewItemData>;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof MarketingChannelOverviewCollectionData
     */
    snapshot?: PrecalculationSnapshotReadMetadata;
}

/**
 * Check if a given object implements the MarketingChannelOverviewCollectionData interface.
 */
export function instanceOfMarketingChannelOverviewCollectionData(value: object): value is MarketingChannelOverviewCollectionData {
    return true;
}

export function MarketingChannelOverviewCollectionDataFromJSON(json: any): MarketingChannelOverviewCollectionData {
    return MarketingChannelOverviewCollectionDataFromJSONTyped(json, false);
}

export function MarketingChannelOverviewCollectionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketingChannelOverviewCollectionData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(MarketingChannelOverviewItemDataFromJSON)),
        'snapshot': json['snapshot'] == null ? undefined : PrecalculationSnapshotReadMetadataFromJSON(json['snapshot']),
    };
}

export function MarketingChannelOverviewCollectionDataToJSON(json: any): MarketingChannelOverviewCollectionData {
    return MarketingChannelOverviewCollectionDataToJSONTyped(json, false);
}

export function MarketingChannelOverviewCollectionDataToJSONTyped(value?: MarketingChannelOverviewCollectionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(MarketingChannelOverviewItemDataToJSON)),
        'snapshot': PrecalculationSnapshotReadMetadataToJSON(value['snapshot']),
    };
}

